/**
 * @generated SignedSource<<644865d5b88b57729a851fc75937f49e>>
 * @relayHash 5b0132b9e5a45c0d4ee5052b7a76599b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/UpdatedContactSellerFormMutation

import { ConcreteRequest } from 'relay-runtime';
export type MessageOpopValidationMode = "SKIP_VALIDATION" | "VALIDATE_AND_IGNORE" | "VALIDATE_AND_THROW" | "%future added value";
export type MessageRedactionMode = "CHECK_AND_IGNORE_REDACTION" | "REDACT" | "SKIP_REDACTION" | "%future added value";
export type SupportedMFATypes = "CODE" | "%future added value";
export type ContactDealerInput = {
  action?: string | null;
  attempt?: number | null;
  buyerId: string;
  captchaKey: string;
  captchaRequestUuid?: string | null;
  captchaToken: string;
  clientMutationId?: string | null;
  currencyConversionRateEventId?: string | null;
  displayName?: string | null;
  isOptIn?: boolean | null;
  itemPk?: string | null;
  messageContent: string;
  mfaVerificationCode?: string | null;
  opopValidationMode?: MessageOpopValidationMode | null;
  pageContext?: string | null;
  redactionMode?: MessageRedactionMode | null;
  sellerPk: string;
  structuredOfferABTestBucket?: string | null;
  supportRequestTypeId?: string | null;
  supportedMFATypes?: ReadonlyArray<SupportedMFATypes | null> | null;
  validateOPOPViolation?: boolean | null;
};
export type UpdatedContactSellerFormMutation$variables = {
  input: ContactDealerInput;
};
export type UpdatedContactSellerFormMutation$data = {
  readonly contactDealer: {
    readonly conversation: {
      readonly serviceId: string | null;
    } | null;
  } | null;
};
export type UpdatedContactSellerFormMutation = {
  response: UpdatedContactSellerFormMutation$data;
  variables: UpdatedContactSellerFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatedContactSellerFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactDealerPayload",
        "kind": "LinkedField",
        "name": "contactDealer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Conversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatedContactSellerFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactDealerPayload",
        "kind": "LinkedField",
        "name": "contactDealer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Conversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/UpdatedContactSellerFormMutation",
    "metadata": {},
    "name": "UpdatedContactSellerFormMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "325bb88e02271790dde1058d071d579b";

export default node;
